exports = module.exports = require("../../../../vue-ssr-factory/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".market-facilitator-main-desc[data-v-6d30679a] {\n  -webkit-line-clamp: 3;\n}\n", ""]);

